import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Modal,
  Pagination,
  PaginationItem,
  Select,
  Typography,
} from "@mui/material";
import ModalReport from "../Generics/ModalReport";
import Header from "../Header";
import SubHeader from "../SubHeader";
import { validationDocument } from "../../utils/ValidationDocument";
import TableReport from "../TableReport";
import ModalConferma from "../Generics/ModalConferma";
import BoxButton from "../BoxButton";
import { useSelector } from "react-redux";
import { service } from "../../model";
import ModalError from "../Generics/ModalError";
import ModalSuccess from "../Generics/ModalSuccess";

const DashboardAdmin = ({}) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const reduxObject = useSelector((state) => state.user?.redux_object);
  const token = reduxObject.accessToken;



  // gestione role & value table
  const intestazioniAdmin = [
    { key: "id", label: "ID" },
    { key: "original_name", label: "Report" },
    { key: "datario", label: "Data" },
    { key: "reader", label: "Lettore" },
    { key: "actions", label: "Modifica" },
  ];

  // filter
  const [filterAnno, setFilterAnno] = useState("");
  const [filterMese, setFilterMese] = useState("");
  const [filterReader, setFilterReader] = useState("");
  // const [filterTeam, setFilterTeam] = useState("");

  const currentYear = new Date().getFullYear();
  const anni = Array.from({ length: currentYear - 2025 }, (_, i) => {
    const year = (2026 + i).toString();
    return { label: year, value: year };
  });

  const mesi = [
    { label: "Gennaio", value: "1" },
    { label: "Febbraio", value: "2" },
    { label: "Marzo", value: "3" },
    { label: "Aprile", value: "4" },
    { label: "Maggio", value: "5" },
    { label: "Giugno", value: "6" },
    { label: "Luglio", value: "7" },
    { label: "Agosto", value: "8" },
    { label: "Settembre", value: "9" },
    { label: "Ottobre", value: "10" },
    { label: "Novembre", value: "11" },
    { label: "Dicembre", value: "12" },
  ];

  const [isLoading, setIsLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState({});
  const [readers, setReaders] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [errors, setErrors] = useState([]);
  const [errorPopup, setErrorPopup] = useState(false);
  const [openModalDocument, setOpenModalDocument] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [openModalConfermaDelete, setOpenModalConfermaDelete] = useState(false);
  const [openModalConfermaUpdate, setOpenModalConfermaUpdate] = useState(false);

  // stati per success/error api
  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const [openModalError, setOpenModalError] = useState(false);
  const [modalSuccessConfig, setModalSuccessConfig] = useState({});
  const [modalErrorConfig, setModalErrorConfig] = useState({});

  // paginazione
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const PER_PAGE = 25; // 25

  // ON-OFF FILTRI
  const [openFilter, setOpenFilter] = useState(false);

  const hasActiveFilters =
    filterAnno !== "" || filterMese !== "" || filterReader !== "";
  const showFilterButton =
    documents.length > 0 || hasActiveFilters || isLoading;

  //
  const showSuccess = (title, descriptionOne, descriptionTwo = "") => {
    setModalSuccessConfig({ title, descriptionOne, descriptionTwo });
    setOpenModalSuccess(true);
  };

  const showError = (title, descriptionOne, descriptionTwo = "") => {
    setModalErrorConfig({ title, descriptionOne, descriptionTwo });
    setOpenModalError(true);
  };

  //
  const loadAppData = async (filters = {}, page = 1) => {
    if (!reduxObject?.accessToken) return;
    const token = reduxObject.accessToken;
    setIsLoading(true);
    try {
      const [users, docs] = await Promise.all([
        service.getAllUsers(token),
        service.getDocuments(token, { ...filters, page, per_page: PER_PAGE }),
      ]);
      setReaders(users);
      setDocuments(
        docs.data.map((doc) => ({
          ...doc,
          reader: doc.reader?.name ?? doc.reader ?? "",
        })),
      );
      setLastPage(docs.last_page);
      setCurrentPage(docs.current_page);
    } catch (err) {
      console.error("Error", err);
    } finally {
      setIsLoading(false);
    }
  };

  //
  useEffect(() => {
    if (!reduxObject?.accessToken) return;

    const selectedReader = readers.find((r) => r.name === filterReader);

    loadAppData({
      year: filterAnno || "",
      month: filterMese || "",
      reader_id: selectedReader?.id || "",
    });
  }, [reduxObject, filterAnno, filterMese, filterReader]);

  const handleOpenEdit = (documentData) => {
    setSelectedDocument(documentData);
    setIsEdit(true);
    setOpenModalDocument(true);
  };

  const handleCloseModalDocument = () => {
    setOpenModalDocument(false);
    setErrors([]);
    setSelectedDocument({});
    setIsEdit(false);
  };

  const handleDeleteDocument = () => {
    setOpenModalConfermaDelete(true);
  };

  const handleUpdateDocument = (documentData) => {
    const validationErrors = validationDocument(documentData);
    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      setErrorPopup(true);
      setTimeout(() => setErrorPopup(false), 3000);
      return;
    }
    setErrors([]);
    setOpenModalConfermaUpdate(true);
  };

  const handleCreateDocument = async (documentData) => {
    const validationErrors = validationDocument(documentData);
    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      setErrorPopup(true);
      setTimeout(() => setErrorPopup(false), 3000);
      return;
    }
    setErrors([]);
    setSelectedDocument(documentData);

    try {
      await service.uploadDocument(token, documentData);
      await loadAppData();
      showSuccess(
        "Report caricato",
        "Il report è stato caricato con successo.",
      );
    } catch (error) {
      console.error("Error", error);
      showError(
        "Errore caricamento",
        "Si è verificato un errore durante il caricamento.",
        "Riprova più tardi.",
      );
    } finally {
      handleCloseModalDocument();
    }
  };

  const handleConfirmDelete = async () => {
    try {
      await service.deleteDocument(token, selectedDocument.id);
      await loadAppData();
      showSuccess(
        "Report eliminato",
        "Il report è stato eliminato con successo.",
      );
    } catch (error) {
      console.error("Error", error);
      showError(
        "Errore eliminazione",
        "Si è verificato un errore durante l'eliminazione.",
        "Riprova più tardi.",
      );
    } finally {
      setOpenModalConfermaDelete(false);
      handleCloseModalDocument();
    }
  };

  const handleConfirmUpdate = async () => {
    const validationErrors = validationDocument(selectedDocument);
    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      setErrorPopup(true);
      setTimeout(() => setErrorPopup(false), 3000);
      return;
    }
    setErrors([]);
    try {
      await service.replaceDocument(token, selectedDocument);
      await loadAppData();
      showSuccess(
        "Report modificato",
        "Il report è stato modificato con successo.",
      );
    } catch (error) {
      console.error("Error", error);
      showError(
        "Errore modifica",
        "Si è verificato un errore durante la modifica.",
        "Riprova più tardi.",
      );
    } finally {
      setOpenModalConfermaUpdate(false);
      handleCloseModalDocument();
    }
  };

  const handleDownload = async (doc) => {
    setIsDownloading(true);
    try {
      const blob = await service.downlaodDocument(token, doc.id);
      const url = window.URL.createObjectURL(blob);
      const link = window.document.createElement("a");
      link.href = url;
      link.download = doc.original_name || "download";
      window.document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error", error);
      showError(
        "Errore download",
        "Impossibile scaricare il file.",
        "Riprova più tardi.",
      );
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      {isDownloading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress sx={{ color: "#fff" }} />
        </div>
      )}

      <div
        style={{ display: "flex", flexDirection: "column", height: "100vh" }}
      >
        <div style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
          <Header />
        </div>
        <Grid
          container
          justifyContent="center"
          sx={{ mt: "140px", px: 2, pb: "80px" }}
        >
          <Grid item xs={12} md={10}>
            <Typography sx={{ fontSize: 22, fontWeight: 600, mb: 3 }}>
              Lista report
            </Typography>

            {/* ON-OFF FILTRI */}
            {showFilterButton && (
              <Grid item xs={12} sx={{ mb: 2 }}>
                <Button
                  variant="outlined"
                  sx={{
                    height: "30px",
                    width: "80px",
                    borderRadius: "10px",
                    borderColor: "#1b2838",
                    textTransform: "initial",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "space-around", sm: "space-between" },
                    px: "15px",
                    "&:hover": {
                      borderColor: "#1b2838",
                      backgroundColor: "#f9f9f9",
                    },
                    // px: openFilter ? "20px" : "20px",
                  }}
                  onClick={() => setOpenFilter((prev) => !prev)}
                >
                  {openFilter ? (
                    <Box
                      className="icon-filter-close-report-button"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  ) : (
                    <Box
                      className="icon-filter-report-button"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  )}

                  <Typography
                    className="color-blue-dark"
                    sx={{
                      fontSize: { xs: "14px", sm: "14px" },
                      fontWeight: 500,
                    }}
                  >
                    Filtri
                  </Typography>
                </Button>
              </Grid>
            )}

            {/* FILTRI */}
            {openFilter && showFilterButton && (
              <Grid container columnSpacing={2} sx={{ mb: 2 }}>
                {/* ANNO */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.5}
                  sx={{ mb: { xs: 2, md: 0 } }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "14px !important",
                        md: "14px !important",
                      },
                      mb: 0.5,
                    }}
                    className="color-blue-dark title-input"
                  >
                    Anno
                  </Typography>
                  <Select
                    value={filterAnno}
                    onChange={(e) => setFilterAnno(e.target.value)}
                    displayEmpty
                    fullWidth
                    sx={{ height: { xs: "40px", md: "40px" } }}
                  >
                    <MenuItem value="">
                      <span style={{ color: "#abb0b6" }}>Seleziona</span>
                    </MenuItem>
                    {anni.map((a) => (
                      <MenuItem key={a.value} value={a.value}>
                        <Typography className="color-blue-dark">
                          {a.label}
                        </Typography>
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* MESE */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.5}
                  sx={{ mb: { xs: 2, md: 0 } }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "14px !important",
                        md: "14px !important",
                      },
                      mb: 0.5,
                    }}
                    className="color-blue-dark title-input"
                  >
                    Mese
                  </Typography>
                  <Select
                    value={filterMese}
                    onChange={(e) => setFilterMese(e.target.value)}
                    displayEmpty
                    fullWidth
                    sx={{ height: { xs: "40px", md: "40px" } }}
                  >
                    <MenuItem value="">
                      <span style={{ color: "#abb0b6" }}>Seleziona</span>
                    </MenuItem>
                    {mesi.map((m) => (
                      <MenuItem key={m.value} value={m.value}>
                        <Typography className="color-blue-dark">
                          {m.label}
                        </Typography>
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {/* READER */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2.5}
                  sx={{ mb: { xs: 2, md: 0 } }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "14px !important",
                        md: "14px !important",
                      },
                      mb: 0.5,
                    }}
                    className="color-blue-dark title-input"
                  >
                    Lettore
                  </Typography>
                  <Select
                    value={filterReader}
                    onChange={(e) => setFilterReader(e.target.value)}
                    displayEmpty
                    fullWidth
                    sx={{ height: { xs: "40px", md: "40px" } }}
                  >
                    <MenuItem value="">
                      <span style={{ color: "#abb0b6" }}>Seleziona</span>
                    </MenuItem>
                    {readers
                      .filter((r) => r.role === "reader")
                      .map((r) => (
                        <MenuItem key={r.id} value={r.name}>
                          <Typography>{r.name}</Typography>
                        </MenuItem>
                      ))}
                  </Select>
                </Grid>

                {/* RESET FILTRI */}
                <Grid
                  item
                  xs={6}
                  sm={1.5}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: { xs: "0px", sm: "28px" },
                  }}
                >
                  <Button
                    variant="outlined"
                    fullWidth
                    sx={{
                      height: "30px",
                      width: "80px",
                      borderRadius: "10px",
                      borderColor: "#c4c4c4",
                      textTransform: "initial",
                      "&:hover": {
                        borderColor: "#1b2838",
                        backgroundColor: "#f9f9f9",
                      },
                    }}
                    onClick={() => {
                      setFilterAnno("");
                      setFilterMese("");
                      setFilterReader("");
                      // setFilterTeam("");
                    }}
                  >
                    {/* <Typography
                      className="color-blue-dark"
                      sx={{
                        fontSize: { xs: "14px", sm: "14px" },
                        fontWeight: 500,
                      }}
                    >
                      Reset
                    </Typography> */}

                    <Box
                      className="icon-filter-reset-report-button"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  </Button>
                </Grid>
              </Grid>
            )}

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <TableReport
                documents={documents}
                onView={handleOpenEdit}
                onDownload={handleDownload}
                intestazioni={intestazioniAdmin}
                isLoading={isLoading}
              />

              {lastPage > 1 && !isLoading && (
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center", mb: 3 }}
                >
                  <Pagination
                    count={lastPage}
                    page={currentPage}
                    onChange={(_, page) => {
                      const selectedReader = readers.find(
                        (r) => r.name === filterReader,
                      );
                      loadAppData(
                        {
                          year: filterAnno || "",
                          month: filterMese || "",
                          reader_id: selectedReader?.id || "",
                        },
                        page,
                      );
                    }}
                    shape="rounded"
                    renderItem={(item) => (
                      <PaginationItem
                        components={{
                          previous: () => (
                            <Box className="icon-arrow-pagination" />
                          ),
                          next: () => (
                            <Box className="icon-arrow-pagination right" />
                          ),
                        }}
                        {...item}
                      />
                    )}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: "#1b2838",
                        borderColor: "#1b2838",
                        borderRadius: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      "& .MuiPaginationItem-icon": {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: 0,
                      },
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "#1b2838",
                        color: "#fff",
                        "&:hover": { opacity: 0.8 },
                      },
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>

          <BoxButton open={setOpenModalDocument} />
        </Grid>
      </div>

      {/* REPORT MODAL */}
      <Modal
        open={openModalDocument}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          handleCloseModalDocument();
        }}
      >
        <Box>
          <ModalReport
            document={selectedDocument}
            setDocument={setSelectedDocument}
            errors={errors}
            confirm={handleCreateDocument}
            onClose={handleCloseModalDocument}
            errorPopup={errorPopup}
            setErrorPopup={setErrorPopup}
            isEdit={isEdit}
            onDelete={handleDeleteDocument}
            onUpdate={handleUpdateDocument}
            readers={readers}
          />
        </Box>
      </Modal>

      {/* MODAL CONFERMA DELETE  */}
      <Modal
        open={openModalConfermaDelete}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          setOpenModalConfermaDelete(false);
        }}
      >
        <Box>
          <ModalConferma
            deleteReport={true}
            title="Elimina report"
            descriptionOne="L'eliminazione di un report è un'azione irreversibile."
            descriptionTwo="Sei sicuro di voler procedere?"
            copyButton="Conferma"
            onClose={() => setOpenModalConfermaDelete(false)}
            confirm={handleConfirmDelete}
          />
        </Box>
      </Modal>

      {/* MODAL CONFERMA UPDATE  */}
      <Modal
        open={openModalConfermaUpdate}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          setOpenModalConfermaUpdate(false);
        }}
      >
        <Box>
          <ModalConferma
            title="Modifica report"
            descriptionOne="Sei sicuro di voler modificare questo report?"
            descriptionTwo="L'operazione non potrà essere annullata."
            copyButton="Conferma"
            onClose={() => setOpenModalConfermaUpdate(false)}
            confirm={handleConfirmUpdate}
          />
        </Box>
      </Modal>

      {/* MODAL SUCCESS */}
      <Modal open={openModalSuccess} onClose={() => setOpenModalSuccess(false)}>
        <Box>
          <ModalSuccess
            title={modalSuccessConfig.title}
            descriptionOne={modalSuccessConfig.descriptionOne}
            descriptionTwo={modalSuccessConfig.descriptionTwo}
            copyButton="Chiudi"
            onClose={() => setOpenModalSuccess(false)}
            confirm={() => setOpenModalSuccess(false)}
          />
        </Box>
      </Modal>

      {/* MODAL ERROR */}
      <Modal open={openModalError} onClose={() => setOpenModalError(false)}>
        <Box>
          <ModalError
            title={modalErrorConfig.title}
            descriptionOne={modalErrorConfig.descriptionOne}
            descriptionTwo={modalErrorConfig.descriptionTwo}
            copyButton="Ok"
            onClose={() => setOpenModalError(false)}
            confirm={() => setOpenModalError(false)}
          />
        </Box>
      </Modal>
    </>
  );
};

export default DashboardAdmin;
